import M from 'backbone.marionette'
import T from './fiche.html'
import { FicheNav } from './fichenav';
import { Loading } from '../../utils/bootstrap/loading';
import { InfoView } from './info';
import { CompetenceView } from './competence';
import { CoursInscritsView } from './coursinscrits/coursinscrits';
import { CoursCompletesView } from './courscompletes';
import { PaiementsView } from './paiements';
import { SuivisView } from './suivis';
import { CandidatDocuments } from './documents';
import { userdata } from '../user';
import Backbone from 'backbone';
import { ProgrammesView } from './programmes';
import localStorage from 'local-storage'
import _ from 'underscore'

const FicheRouteur = Backbone.Router.extend({
    preinitialize: function (options) {
        options.navItems.forEach((item) => {
            if(item.get('view')){
                this.routes[item.get('id')] = item.get('id');
            }
        })
    },
    routes: {},
})


export const getNavItems = (NoEtudiant, urlOnly) => {
    
    const c = new Backbone.Collection();
    if(userdata('Type') == 'contributeur'){
        c.reset([
            { id: 'info', title: 'Informations', view: InfoView, urlOnly: urlOnly, url: './candidat/fiche/' + NoEtudiant + '#info' },
            { id: 'programmes', title: 'Programme(s)', view: ProgrammesView, urlOnly: urlOnly, url: './candidat/programmes/' + NoEtudiant + '#programmes' },
            { id: 'competences', title: 'Compétences programmes', view: CompetenceView, urlOnly: urlOnly, url: './candidat/fiche/' + NoEtudiant + '#competences' },
            { id: 'coursinscrits', title: 'Cours inscrits', view: CoursInscritsView, urlOnly: urlOnly, url: './candidat/fiche/' + NoEtudiant + '#coursinscrits' },
            { id: 'courscompletes', title: 'Cours complétés', view: CoursCompletesView, urlOnly: urlOnly, url: './candidat/fiche/' + NoEtudiant + '#courscompletes' },
            { id: 'paiements', title: 'Paiements', view: PaiementsView, urlOnly: urlOnly, url: './candidat/fiche/' + NoEtudiant + '#paiements' },
            { id: 'suivis', title: 'Suivis publics', view: SuivisView, urlOnly: urlOnly, url: './candidat/fiche/' + NoEtudiant + '#suivis' },
            { id: 'conversation', title: 'Conversation RAC', urlOnly: urlOnly, url: './candidat/conversation/' + NoEtudiant },
            { id: 'documents', title: 'Documents', view: CandidatDocuments, urlOnly: urlOnly, url: './candidat/fiche/' + NoEtudiant + '#documents' }
        ]);
    }else{
        c.reset([
            { id: 'competences', title: 'Compétences programmes', view: CompetenceView, urlOnly: urlOnly, url: './candidat/fiche/' + NoEtudiant + '#competences' },
            { id: 'suivis', title: 'Suivis', view: SuivisView, urlOnly: urlOnly, url: './candidat/fiche/' + NoEtudiant + '#suivis' },
            { id: 'documents', title: 'Documents', view: CandidatDocuments, urlOnly: urlOnly, url: './candidat/fiche/' + NoEtudiant + '#documents' }
        ]);
    }
    return c
}

const EnseignantModel = Backbone.Model.extend({ idAttribute: 'NoEnseignant' });
const EnseignantCollection = Backbone.Collection.extend({ model: EnseignantModel });

const FicherController = Backbone.Model.extend({
    updateListeCompens: function(){
        $.ajax({
            url: 'api/etudiants/listecompens/' + this.get('etudiant').get('NoEtudiant'),
            cache: false,
            success: (response) => {
                this.get('listecompens').reset(response);
            }
        })
    },
    hydrate: function(data){
        
        this.get('inscriptionp').reset(data.inscriptionp);
        this.get('programmes').reset(data.programmes);
        this.get('programmecours').reset(data.programmecours);

        if(userdata('Type') === 'contributeur'){
            
            this.get('paiement').reset(data.paiement);
            this.get('paiement_types').reset(_.map(data.paiement_types, (item) => { return { value: item } }));
            this.get('paiement_modes').reset(_.union([''], _.map(data.paiement_modes, (item) => { return { value: item } })));
            this.get('invitations').reset(data.invitations);
            
        }
        this.get('inscriptionc').reset(data.inscriptionc);
        this.get('etudiant').set(data.etudiant);
        this.get('competenceetudiant').reset(data.competenceetudiant);
        this.get('listecompetences').reset(data.listecompetences);
        this.get('listecompens').reset(data.listecompens);
        this.get('enseignants').reset(data.enseignants);
        this.get('types_suivis').reset(_.union([''], _.map(data.types_suivis, (item) => { return { value: item } })));
        this.get('suivi').reset(data.suivi);
        this.get('suiviusers').reset(data.suiviusers);
        this.get('documents').reset(data.documents);
        this.get('utilisateurs').reset(data.utilisateurs);
        this.get('etudiantevals').reset(data.etudiantevals);

        let currentInscriptionP = localStorage('currentInscriptionP:' + this.get('etudiant').get('NoEtudiant'));
        if(!currentInscriptionP){
            currentInscriptionP = this.get('currentInscriptionP') ? this.get('currentInscriptionP') : this.get('inscriptionp').at(0).get('NoInscription')
            this.updateCurrentInscriptionP(parseInt(currentInscriptionP));
        }else{
            this.setCurrentInscriptionP(parseInt(currentInscriptionP))
        }

        // TOUJOURS FAIRE çA EN DERNIER !
        this.set('loading', false);
    },
    updateCurrentInscriptionP: function(NoInscription){
        if(this.get('inscriptionp').get(NoInscription)){
            console.log('updateCurrentInscriptionP', NoInscription)
            localStorage('currentInscriptionP:' + this.get('etudiant').get('NoEtudiant'), NoInscription);            
            this.setCurrentInscriptionP(NoInscription)
        }
    },
    setCurrentInscriptionP: function(NoInscription){
        //this.set('currentInscriptionP', NoInscription);
        console.log('setCurrentInscriptionP', NoInscription)
        const currInscriptionP = this.get('inscriptionp').get(NoInscription);
        const cours = this.get('programmecours').where({'NoProgramme': currInscriptionP.get('NoProgramme')});
        const coursIds = cours.map(p => p.get('NoCours'))
        console.log('coursIds', coursIds)
        //this.set('currCours', coursIds);
        const competenceIds = this.get('listecompetences').filter(p => coursIds.includes(p.get('NoCours'))).map(p => p.get('NoCompetence'))
        //this.set('currCompetences', competenceIds);
        this.set({
            currentInscriptionP: NoInscription,
            currentProgramme: currInscriptionP.get('NoProgramme'),
            currCours: coursIds,
            currCompetences: competenceIds
        });
    },
    updateInscriptionP: function(){
        $.ajax({
            url: 'api/etudiants/inscriptionp/' + this.get('etudiant').get('NoEtudiant'),
            cache: false,
            success: (response) => {
                this.get('inscriptionp').reset(response);
            }
        })
    }
});

export const FicheView = M.View.extend({
    template: _.template(T),
    regions: {
        'nav': '#ficheNav',
        'content': '#ficheContent',
    },
    views: null,
    childViewEventPrefix: 'childview',
    modelEvents: {
        'change:loading': 'render',
        'change:currentTab': 'render'
    },
    router: null,
    navItems: null,
    initialize: function () {
        this.navItems = getNavItems(this.getOption('id'), false)
        this.model = new FicherController({
            currentTab: this.getOption('tab') ? this.getOption('tab') : this.navItems.at(0).get('id'),
            currentInscriptionP: null,
            loading: true,
            etudiant: new Backbone.Model(),
            programmes: new Backbone.Collection(),
            inscriptionp: new Backbone.Collection(),
            competenceetudiant: new Backbone.Collection(),
            inscriptionc: new Backbone.Collection(),
            programmecours: new Backbone.Collection(),
            listecompetences: new Backbone.Collection(),
            listecompens: new Backbone.Collection(),
            enseignants: new EnseignantCollection(),
            paiement: new Backbone.Collection(),
            paiement_types: new Backbone.Collection(),
            paiement_modes: new Backbone.Collection(),
            types_suivis: new Backbone.Collection(),
            suivi: new Backbone.Collection(),
            suiviusers: new Backbone.Collection(),
            documents: new Backbone.Collection(),
            utilisateurs: new Backbone.Collection(),
            invitations: new Backbone.Collection(),
            etudiantevals: new Backbone.Collection(),
            newProgram: new Backbone.Model(),
            currCours: [],
            currCompetences: []
        });

        this.router = new FicheRouteur({navItems: this.navItems});
        this.navItems.forEach((item) => {
            if(item.get('view')){
                this.router.on('route:' + item.get('id'), () => {
                    this.model.set('currentTab', item.get('id'))
                })
            }else{
                if(item.get('id')==='conversation'){
                    item.set('url', './candidat/conversation/' + this.getOption('id'))
                }
            }
        })
        Backbone.history.start();

        this.views = _.clone(this.navItems);
        /*if(this.$el.text()) this.hydrateController(JSON.decode(atob(this.$el.text())));
        else*/ this.loadData();
    },
    loadData: function () {
        $.ajax({
            url: 'api/etudiants/data/' + this.getOption('id'),
            cache: false,
            success: (response) => {
                this.model.hydrate(response);
            },
            error: () => {
                this.showChildView('content', new M.View({ template: _.template('<h2>Erreur de chargement</h1>') }));
            }
        })
    },
    onRender: function () {
        if (this.model.get('loading')) {
            this.showChildView('content', new Loading());
        } else {
            this.showChildView('nav', new FicheNav({
                model: this.model,
                collection: this.views
            }));
            const viewItem = this.views.get(this.model.get('currentTab'));
            const viewClass = viewItem.get('view');
            let viewOptions = _.extend(
                { model: this.model },
                viewItem.get('viewOptions') ? viewItem.get('viewOptions') : {},
                { controller: this.model }
            );
            const view = new viewClass(viewOptions);
            this.showChildView('content', view);
        }
    },
    onChildviewChangeTab: function (tabId) {
        const viewItem = this.views.get(tabId);
        if (tabId != this.model.get('currentTab') && viewItem) {
            this.model.set('currentTab', tabId);
        }
    },
    onDataReceived: function(ficheData){
        console.log('re-hydrate fiche data !');
        this.model.hydrate(ficheData);
    }

})
